module.exports = __webpack_public_path__ + "static/media/asset5.c5de304a.png";